import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import './less/index.less'


Vue.config.productionTip = false
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import Layout from './components/Layout.vue'
Vue.component('layout', Layout)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
	  /* 路由发生变化修改页面title */
	  if (to.meta.title) {
	    document.title = to.meta.title
	  }
	  next()
	})



// WEBPACK FOOTER //
// ./src/main.js